import { sendEvent } from 'constants/mixpanelHelper';
import { VIEWS_EVENTS } from 'constants/trackingEvents';

export const sendCreateViewEvent = ({ eventName = VIEWS_EVENTS.CREATE_VIEW, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenManageViewsEvent = ({ eventName = VIEWS_EVENTS.OPEN_MANAGE_VIEWS, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendApplyAndSaveEvent = ({ eventName = VIEWS_EVENTS.APPLY_AND_SAVE_VIEW, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendApplyViewEvent = ({ eventName = VIEWS_EVENTS.APPLY_VIEW, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSearchValueEvent = ({ eventName = VIEWS_EVENTS.SEARCH_VALUES, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewsFilterButtonClicked = ({
  eventName = VIEWS_EVENTS.VIEWS_FILTER_BUTTON_CLICKED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewsMenuCloneClicked = ({
  eventName = VIEWS_EVENTS.VIEWS_MENU_CLONE_CLICKED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewsMenuEditClicked = ({
  eventName = VIEWS_EVENTS.VIEWS_MENU_EDIT_CLICKED,
  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewsMenuDeleteClicked = ({
  eventName = VIEWS_EVENTS.VIEWS_MENU_DELETE_CLICKED,

  eventProperties = {},
}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUploadCsvInNames = ({ eventName = VIEWS_EVENTS.UPLOAD_CSV_IN_NAMES, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};
